import React from 'react';
import PropTypes from 'prop-types';
import IconNikeAI from '../IconNikeAI';
import { StyledButton } from './styles';

/**
 * Nike AI Shimmer Button
 * Reusable shimmer button component for Nike AI entry points
 * Used by both FAB and AskNikeAI search result
 *
 * @param {Object} props
 * @param {Function} props.onClick - Click handler
 * @param {string} props.ariaLabel - Accessible label
 * @param {string} props.size - 'small' (48px) or 'large' (62px desktop, 56px mobile)
 * @param {string} props.variant - 'animated' (shimmer) or 'static' (gradient)
 * @param {string} props.className - Additional CSS class
 * @param {number} props.tabIndex - Tab index for accessibility
 * @param {boolean} props.asDiv - TG-8222: Render as div when inside button container (prevents button nesting)
 */
const NikeAIShimmerButton = ({
  onClick,
  ariaLabel = 'Nike AI',
  size = 'small',
  variant,
  className = '',
  tabIndex = 0,
  asDiv = false,
}) => {
  return (
    <StyledButton
      aria-label={ariaLabel}
      as={asDiv ? 'div' : 'button'}
      className={className}
      onClick={onClick}
      size={size}
      tabIndex={tabIndex}
      type={asDiv ? undefined : 'button'}
      variant={variant}
    >
      <IconNikeAI ariaLabel="" />
    </StyledButton>
  );
};

NikeAIShimmerButton.propTypes = {
  ariaLabel: PropTypes.string,
  asDiv: PropTypes.bool,
  className: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  size: PropTypes.oneOf(['small', 'large']),
  tabIndex: PropTypes.number,
  variant: PropTypes.oneOf(['animated', 'static']),
};

NikeAIShimmerButton.defaultProps = {
  ariaLabel: 'Nike AI',
  asDiv: false,
  className: '',
  size: 'small',
  tabIndex: 0,
  variant: 'animated',
};

export default NikeAIShimmerButton;
